export default __webpack_public_path__ + "static/media/sideNavLogo.203cf9e8.png";